import { useEffect, useRef, useState } from 'react';
import Username from '../Username';
import Devices from './Devices';
import Products from './Products';
import { isMobile } from '../../../utils/constants';
import TableSkeleton from '../../common/skeletons/TableSkeleton';

const TVsAndSoundBars = () => {
	const tvsoundbarContainerFocusRef: any = useRef<HTMLDivElement>(null);
	const tvsoundbarTabindex = !isMobile ? { tabIndex: -1 } : {};
	const [tvsCount, setTvsCount] = useState(0);
	const [productsCount, setProductsCount] = useState(0);
	const [isWebSupportModalOpen, setIsSupportModalOpen] = useState(false);
	const [serialNumberShow, setSerialNumberShow] = useState(false);
	const [showElement, setShowElement] = useState(true);
	const handleSupportModal = (e: any) => {
		setIsSupportModalOpen(true);
		setSerialNumberShow(true);
	};

	const callbackTvs = (payload: any) => {
		setTvsCount(payload);
	};
	const callbackProducts = (payload: any) => {
		setProductsCount(payload);
	};

	const updateSupportModalToggle = (isUpdateSupportModalOpen: any, isUpdateSerialNumber: any) => {
		setIsSupportModalOpen(isUpdateSupportModalOpen);
		setSerialNumberShow(isUpdateSerialNumber);
	};

	useEffect(() => {
		if (tvsoundbarContainerFocusRef.current) {
			tvsoundbarContainerFocusRef.current.focus();
		}
		setTimeout(function () {
			setShowElement(false);
		}, 5000);
	}, []);

	return (
		<div className="tv-soundbar">
			<div className="account-component subs-components soundbar-components">
				<Username />

				{showElement ? (
					<TableSkeleton />
				) : tvsCount === 0 && productsCount === 0 ? (
					<div className="navsupport">
						<div className="navsupport-info">
							Have a question? You can now contact VIZIO Support through your VIZIO Account.
						</div>
						<button
							type="button"
							className="secondary-button-small"
							onClick={handleSupportModal}
							aria-label="VIZIO Support">
							Support
						</button>
					</div>
				) : (
					<div></div>
				)}

				<div
					className="sb-pr-component sub-purchase-comp"
					ref={tvsoundbarContainerFocusRef}
					{...tvsoundbarTabindex}>
					<Devices
						isWebSupportModalOpen={isWebSupportModalOpen}
						serialNumberShow={serialNumberShow}
						updateSupportModalToggle={(
							isUpdateSupportModalOpen: boolean,
							isUpdateSerialNumber: boolean
						) => updateSupportModalToggle(isUpdateSupportModalOpen, isUpdateSerialNumber)}
						callbackTvs={callbackTvs}
					/>
				</div>
				<div className="sb-pr-component sub-purchase-comp reg-product">
					<Products callbackProducts={callbackProducts} />
				</div>
			</div>
		</div>
	);
};

export default TVsAndSoundBars;
